const dashboardApiUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, "");
const BASE_URL = (
  process.env.REACT_APP_ADS_AGENT_API_URL
  || (dashboardApiUrl ? `${dashboardApiUrl}/api/ads-agent` : "http://127.0.0.1:5055/api/ads-agent")
).replace(/\/$/, "");

async function request(path, options = {}) {
  let response;
  try {
    response = await fetch(`${BASE_URL}${path}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  } catch {
    throw new Error(`Ads Agent is offline. Start the backend at ${BASE_URL}.`);
  }

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body?.error?.message || body?.message || `Request failed (${response.status}).`);
  }
  return body;
}

export const adsOptimizerAPI = {
  baseUrl: BASE_URL,
  health: () => request("/health"),
  providers: () => request("/v1/agent/providers"),
  usage: () => request("/v1/agent/usage?days=30"),
  accounts: () => request("/v1/accounts"),
  entitlements: (accountId) => request(`/v1/accounts/${accountId}/entitlements`),
  updateEntitlements: (accountId, body) => request(`/v1/accounts/${accountId}/entitlements`, {
    method: "PATCH",
    body: JSON.stringify(body),
  }),
  accountAudit: (accountId, currentRange, previousRange) => request(`/v1/accounts/${accountId}/audits/ad-account`, {
    method: "POST",
    body: JSON.stringify({ currentRange, previousRange }),
  }),
  conversionTrackingAudit: (accountId) => request(`/v1/accounts/${accountId}/audits/conversion-tracking`, {
    method: "POST",
    body: JSON.stringify({}),
  }),
  competitors: (accountId) => request(`/v1/accounts/${accountId}/competitor-transparency`),
  addCompetitor: (accountId, body) => request(`/v1/accounts/${accountId}/competitor-transparency`, {
    method: "POST",
    body: JSON.stringify(body),
  }),
  intelligence: (accountId) => request(`/v1/accounts/${accountId}/intelligence`),
  linkIntelligence: (accountId, collectionName) => request(`/v1/accounts/${accountId}/intelligence-link`, {
    method: "PATCH",
    body: JSON.stringify({ collectionName }),
  }),
  performance: (accountId, currentRange, previousRange) => request(
    `/v1/accounts/${accountId}/analysis/performance`,
    {
      method: "POST",
      body: JSON.stringify({ currentRange, previousRange, targets: {} }),
    },
  ),
  proposals: (accountId) => request(`/v1/action-proposals?accountId=${encodeURIComponent(accountId)}`),
  teamInsights: (accountId) => request(`/v1/accounts/${accountId}/team-insights`),
  createTeamInsight: (accountId, body) => request(`/v1/accounts/${accountId}/team-insights`, {
    method: "POST",
    body: JSON.stringify(body),
  }),
  archiveTeamInsight: (insightId) => request(`/v1/team-insights/${insightId}`, {
    method: "PATCH",
    body: JSON.stringify({ status: "ARCHIVED" }),
  }),
  proposal: (proposalId) => request(`/v1/action-proposals/${proposalId}`),
  updateProposal: (proposalId, body) => request(`/v1/action-proposals/${proposalId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  }),
  sendMessage: ({ accountId, threadId, message, provider, model }) => request("/v1/agent/messages", {
    method: "POST",
    body: JSON.stringify({ accountId, ...(threadId ? { threadId } : {}), message, ...(provider ? { provider } : {}), ...(model ? { model } : {}) }),
  }),
  threadMessages: (threadId) => request(`/v1/agent/threads/${threadId}/messages`),
  approveProposal: (proposalId, expectedPayloadHash) => request(`/v1/action-proposals/${proposalId}/approve`, {
    method: "POST",
    body: JSON.stringify({ expectedPayloadHash }),
  }),
  rejectProposal: (proposalId, reason) => request(`/v1/action-proposals/${proposalId}/reject`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  }),
  verifyProposal: (proposalId) => request(`/v1/action-proposals/${proposalId}/verify`, {
    method: "POST",
    body: JSON.stringify({}),
  }),
};
